<ng-container *transloco="let t">
    <div *ngIf="inited" class="grid">
        <div class="col-12" style="text-align: left">
            <p-button class="mr-1" icon="fas fa-save" [label]="app.t('general.save')" (onClick)="save()">
            </p-button>
            <p-button icon="fas fa-times" [label]="app.t('general.cancel')" (onClick)="cancel()">
            </p-button>
        </div>
        <div class="col-12 grid">
            <p-card class="col-12 md:col-6">
                <sm-form [form]="form">
                </sm-form>
            </p-card>
            <p-tree #tree class="col-6" [value]="pupilsTree.items" selectionMode="checkbox" [(selection)]="pupilsTree.selected"></p-tree>
        </div>
    </div>
</ng-container>
